import { NgModule } from '@angular/core';
import { NgxMenuFloatComponent } from './ngx-menu-float.component';
import {CommonModule} from '@angular/common';



@NgModule({
  declarations: [NgxMenuFloatComponent],
  imports: [
    CommonModule,
  ],
  exports: [NgxMenuFloatComponent]
})
export class NgxMenuFloatModule { }
